import { Box, Card, CardHeader, Container, TextField, Button, Typography, CircularProgress } from '@mui/material';
import Page from '../components/Page';
import { useState } from 'react';
import api from '../api';
import searchIcon from '@iconify/icons-eva/search-outline';
import { Icon } from '@iconify/react';

export default function Dictionary() {
    const [searchWord, setSearchWord] = useState('');
    const [translation, setTranslation] = useState(null);
    const [loading, setLoading] = useState(false);
    const [searched, setSearched] = useState(false);

    const handleSearch = () => {
        if (searchWord.trim() === '') return;
        
        setLoading(true);
        setSearched(true);
        api.get('/en-uz/translation?word=' + searchWord.trim()).then(function (response) {
            return response;
        }).then(function (resultData) {
            if (resultData.success) {
                let pronounciation = '';
                let cnt = 0;
                if (resultData.data.length > 0) {
                    let res = resultData.data.map(function (item, i) {
                        cnt++;
                        pronounciation = " [" + item.pronunciation + "]";
                        for (var k = 1; k <= 20; k++) {
                            if (item.translation.includes(k + ' ')) {
                                if (k > 1) {
                                    item.translation = item.translation.replace(k + ' ', '<br>' + k + '. ');
                                } else {
                                    item.translation = item.translation.replace(k + ' ', k + '. ');
                                }
                            } else {
                                break;
                            }
                        }
                        if (cnt == 1) {
                            return '<br>' + item.translation + "<hr>";
                        } else {
                            return item.translation + "<hr>";
                        }
                    }).join(' ');
                    setTranslation({ word: resultData.word + pronounciation, detail: res });
                } else {
                    setTranslation({ 
                        word: resultData.word, 
                        detail: "<hr><span style='color:red'>Sorry! The word was not found in our dictionary.</span>" 
                    });
                }
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
            setTranslation({ 
                word: searchWord, 
                detail: "<hr><span style='color:red'>An error occurred. Please try again.</span>" 
            });
        });
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Page title="Dictionary | eagles.uz">
            <Container>
                <Card sx={{ mt: 3 }}>
                    <CardHeader title="Dictionary" subheader="Search for words and see their translations" />
                    
                    <Box sx={{ p: 3 }}>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                            <TextField
                                fullWidth
                                label="Enter word"
                                variant="outlined"
                                value={searchWord}
                                onChange={(e) => setSearchWord(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="Example: hello"
                                autoFocus
                            />
                            <Button
                                variant="contained"
                                size="large"
                                onClick={handleSearch}
                                disabled={loading || searchWord.trim() === ''}
                                sx={{ minWidth: 120, height: 56 }}
                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Icon icon={searchIcon} />}
                            >
                                Search
                            </Button>
                        </Box>

                        {searched && translation && (
                            <Box sx={{ mt: 4, p: 3, bgcolor: 'background.neutral', borderRadius: 2 }}>
                                <Typography variant="h4" sx={{ mb: 2 }}>
                                    {translation.word}
                                </Typography>
                                <Typography 
                                    variant="body1" 
                                    sx={{ fontSize: 18, lineHeight: 1.8 }} 
                                    dangerouslySetInnerHTML={{ __html: translation.detail }}
                                />
                            </Box>
                        )}

                        {!searched && (
                            <Box sx={{ mt: 4, textAlign: 'center', py: 5 }}>
                                <Icon icon={searchIcon} width={80} height={80} style={{ opacity: 0.3 }} />
                                <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
                                    Enter a word and press the search button
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Card>
            </Container>
        </Page>
    );
}
